import * as React from "react";
import { UserWorkStatus } from "../../types/users";
import SelectBase, { SelectOption } from "../../components/global/SelectBase";

const workStatuses: SelectOption[] = [
  {
    label: "Sole Proprietor",
    value: UserWorkStatus.SOLE_PROPRIETOR,
  },
  {
    label: "Part Time",
    value: UserWorkStatus.PART_TIME,
  },
  {
    label: "Entrepreneur",
    value: UserWorkStatus.ENTREPRENEUR,
  },
];

const SelectWorkStatus = ({
  onChange,
  value,
  error,
  helperText,
}: {
  onChange: (value?: string) => void;
  value: string;
  error?: boolean;
  helperText?: React.ReactNode;
}) => {
  const selected = React.useMemo<SelectOption | null>(
    () => workStatuses?.find((it) => it.value == value) || null,
    [value]
  );

  return (
    <SelectBase
      options={workStatuses}
      value={selected}
      onChange={(newValue) => {
        const option = newValue as SelectOption | null;
        onChange(option?.value as string | undefined);
      }}
          label="Work Status"
          placeholder="Select Work Status..."
          error={error}
          helperText={helperText}
      isMulti={false}
      isSearchable={false}
    />
  );
};
export default SelectWorkStatus;
